export default [
  '$rootScope',
  '$q',
  'httpResponseErrorService',
  ($rootScope, $q, httpResponseErrorService) => {
    return {
      request: config => {
        return config;
      },
      response: response => {
        return response;
      },
      responseError: rejection => {
        let isReject = true;

        if (rejection.status === 401) {
          $rootScope.$broadcast('http.unauthorized');
        }

        if (rejection.status === 403) {
          $rootScope.$broadcast('http.forbidden');
        }

        // status = -1 - запрос отменен по config.timeout
        if (![-1, 401, 403, 400, 404].includes(rejection.status)) {
          // allowServerErrors - флаг для идентификации запроса, для которого статус ошибка сервера является успешным
          if (rejection.allowServerErrors || rejection.config.allowServerErrors) {
            isReject = false;
          } else if (!httpResponseErrorService.omitErrorNotification(rejection.config)) {
            $rootScope.$broadcast('http.serverError', rejection);
          }
        }

        return isReject ? $q.reject(rejection) : $q.resolve(rejection);
      },
    };
  },
];
